import { render, staticRenderFns } from "./documentTemplateView.vue?vue&type=template&id=eec1d31c"
import script from "./documentTemplateView.vue?vue&type=script&lang=js"
export * from "./documentTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports